import { ClassificationLevel } from '@sonar-software/sonar-core';
import { ClassificationTag } from './ClassificationTag';
import { enumStringKeys } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarSelector } from '../SonarSelector';

const options = enumStringKeys(ClassificationLevel).map((key) => ({
	label: <ClassificationTag classification={ ClassificationLevel[ key ] } />,
	optionLabel: <ClassificationTag classification={ ClassificationLevel[ key ] } />,
	value: ClassificationLevel[ key ]
}));

export interface ClassificationSelectorProps {
	boxless?: boolean;
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	isSpreadsheet?: boolean;
	onChange?: (value: ClassificationLevel) => void;
	value?: ClassificationLevel;
}

export const ClassificationSelector: React.FC<ClassificationSelectorProps> = ({
	boxless,
	getPopupContainer,
	isSpreadsheet,
	onChange,
	value
}) =>
	<SonarSelector
		allowClear={ Boolean(value) }
		boxless={ boxless ?? !isSpreadsheet }
		className='app-classification-selector'
		defaultValue={ value ?? ClassificationLevel.None }
		getPopupContainer={ getPopupContainer }
		isSalesforce
		isSpreadsheet={ isSpreadsheet }
		onChange={ onChange }
		options={ options }
		readOnlyDisplay={ <ClassificationTag classification={ value } /> }
		showArrow
		showSearch={ false } />;
